const templates =  {
    "shop.okraina.ru": {
        title: "Купоны в магазинах",
        tags: [

        ]
    },
    "dostavka.okraina.ru": {
        title: "Купоны в магазинах",
        tags: [

        ]
    },
}

export default templates;